import React from "react";
import Loadable from "../../react-loadable";

const Com = Loadable({
  loader: () => import("./TablePage"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-table-page/index.js